import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const ActivityAndMovementJumbotron = () => {
  return (
    <section className="py-8" data-cy="activity-and-movement-jumbotron">
      <LandingPageJumbotron
        description="activity_jumbotron_title"
        title="activity_jumbotron_eyebrow"
        theme="brown"
      />
    </section>
  );
};

export default ActivityAndMovementJumbotron;
